import React from 'react';

const TimezoneSelector = ({ value, onChange, label = "Timezone", className = "" }) => {
  // Generate the full list of IANA timezones
  const timezones = Intl.supportedValuesOf('timeZone').map(tz => ({
    label: tz.replaceAll('_', ' '),
    value: tz
  }));

  return (
    <div className={`mt-4 form-group ${className}`}>
      {label && <h4 style={{fontWeight: 500}}>{label}</h4>}
      <select 
        className="form-control"
        style={{ fontSize: '0.9rem', borderRadius: '8px' }}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {timezones.map((tz) => (
          <option key={tz.value} value={tz.value}>
            {tz.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TimezoneSelector;